/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { chatMessageModelPagedResultSchema } from "./chatMessageModelPagedResultSchema.ts";
import { chatMessageModelSchema } from "./chatMessageModelSchema.ts";
import { chatStatusEnumSchema } from "./chatStatusEnumSchema.ts";
import { chatTypeEnumSchema } from "./chatTypeEnumSchema.ts";
import { fileModelSchema } from "./fileModelSchema.ts";
import { z } from "zod";

export const chatModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор чата"),
"name": z.string().describe("Название чата"),
"type": z.lazy(() => chatTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - System</b>: Системные сообщения</li>\n<li><b>2 - Feedback</b>: Обратная связь</li>\n<li><b>3 - Radio</b>: Радио</li>\n</ul>\n"),
"status": z.lazy(() => chatStatusEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>0 - NotDefined</b>: </li>\n<li><b>1 - Opened</b>: Чат открыт</li>\n<li><b>2 - Closed</b>: Чат закрыт</li>\n</ul>\n"),
"messages": z.lazy(() => chatMessageModelPagedResultSchema).and(z.object({
    "items": z.array(z.lazy(() => chatMessageModelSchema))
    })).describe("Сообщения"),
"chatPartnerAvatar": z.lazy(() => fileModelSchema).describe("Аватар пользователя-собеседника").nullable().nullish()
    })